import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";

import { AuthenticationContext } from "../context";
import { ViewRequest, request } from "./request";

export const listProcedureCodes = async (authToken: string, body?: Partial<ViewRequest> & ProcedureCodeListRequest) => {
  return request<typeof body, ProcedureCodeListResponse>(
    {
      endpoint: "/procedure_code/list",
      body: { ...body },
    },
    authToken,
  );
};

export const useListProcedureCodesQuery = (body: ProcedureCodeListRequest, enabled?: boolean) => {
  const { getAuthToken } = useContext(AuthenticationContext);

  const query = useQuery({
    queryFn: async () => {
      return listProcedureCodes(await getAuthToken(), { ...body });
    },
    queryKey: ["procedureCodeList",
      body?.code || "",
      body?.codes || "",
      body?.code_or_description || "",
      body?.client_ids || "",
      body?.include_custom_codes || "",
      body?.expected_fields || "",
      body?.page_number || 1,
      body?.results_per_page || 10],
    enabled: enabled,
  });

  return query;
};

export interface ProcedureCodeListRequest {
  readonly code?: string | null;
  readonly codes?: [string] | null;
  readonly code_or_description?: string | null;
  readonly client_ids?: [string] | null;
  readonly include_custom_codes?: boolean | null;
  readonly page_number?: string;
  readonly results_per_page?: string;
  readonly expected_fields?: string;
}

export interface ProcedureCodeListObject {
  readonly id: number;
  readonly code: string;
  readonly type: string;
  readonly short_description: string;
  readonly long_description: string;
}

interface ProcedureCodeListResponse {
  results: {
    procedure_code: ProcedureCodeListObject;
  }[];
  result_count: string;
}
